import makeStyles from '@mui/styles/makeStyles'

export const ANIMATION_DELAY = 200

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '-80px',
    borderRight: ({ open, fullyClosed }) =>
      open || !fullyClosed ? '1px solid #C6C6C6' : 'none',
    boxSizing: 'border-box',
    width: ({ open, narrow, isSmall }) =>
      isSmall
        ? '100%'
        : open
        ? `calc(384px - ${narrow ? '144px' : '0px'})`
        : '0px',
    padding: ({ showContent }) => (showContent ? '25px 24px' : '0'),
    background: 'white',
    transition: `width ${ANIMATION_DELAY}ms ease-in-out`,
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
    [theme.breakpoints.down(1025)]: {
      width: ({ open, narrow, isSmall }) =>
        isSmall
          ? '100%'
          : open
          ? `calc(384px - ${narrow ? '184px' : '0px'})`
          : '0px',
      padding: ({ showContent }) => (showContent ? '25px 12px' : '0')
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginTop: ({ absoluteTitle }) => (absoluteTitle ? '-27px' : '-25px'),
    marginLeft: '-24px',
    marginRight: '-24px',
    marginBottom: ({ hasSubcomponent }) => !hasSubcomponent && '25px',
    borderBottom: ({ hasSubcomponent }) =>
      !hasSubcomponent && '1px solid #C6C6C6',
    boxSizing: 'border-box',
    height: '80px',
    paddingLeft: '24px',
    fontSize: theme.size.lg,
    position: ({ absoluteTitle }) => (absoluteTitle ? 'absolute' : 'static'),
    color: ({ open }) => (open ? '#1F1F1F' : 'transparent'),
    cursor: 'default',
    [theme.breakpoints.down(1025)]: {
      marginLeft: '-12px',
      marginRight: '-12px'
    }
  },

  button: {
    position: 'absolute',
    top: ({ hasSubcomponent }) => (!hasSubcomponent ? '96px' : '19px'),
    right: ({ isSmall }) => (isSmall ? '28px' : '0'),
    padding: '8px',
    cursor: 'pointer',
    transform: ({ open }) => `translateX(50%) rotate(${open ? 0 : 180}deg)`
  },

  children: {
    height: ({ bottomNavHeight }) => `calc(100% - 80px + ${bottomNavHeight}px)`
  },

  bottomBorder: {
    borderBottom: '1px solid #C6C6C6',
    paddingLeft: '24px',
    marginLeft: '-24px',
    marginRight: '-24px',
    paddingTop: ({ absoluteTitle }) => absoluteTitle && `32px`,
    [theme.breakpoints.down(1025)]: {
      marginLeft: '-12px',
      marginRight: '-12px'
    }
  }
}))

export default useStyles
